export const SUMMARY_FEEDBACK_STATUS = {
  APPROVED: 'approved',
  NOT_APPROVED: 'not_approved',
  OTHER: 'other'
}

export const SUMMARY_TYPES = {
  APPROVED: ["low_risk"],
  NOT_APPROVED: ["performance_review", "hr_complaint", "investigation"],
};
